import { AuthConfig } from '@domgen/dgx-fe-authentication';
import { AppConfig } from '../../models/config/app-config.type';

export type CognitoPool = {
  cognitoPool: {
    userPoolId: string;
    clientId: string;
  };
};

export const authConfigFactory = (
  config: AppConfig
): AuthConfig &
  CognitoPool & {
    myAccountLogoutPage: string;
    myAccountBaseDomain: string;
    domain: string;
  } => ({
  authApi: config.authApi,
  recaptchaSession: false,
  userApi: config.userApi,
  cognitoPool: {
    userPoolId: config.cognitoPool.userPoolId,
    clientId: config.cognitoPool.clientId,
  },
  myAccountLogoutPage: config.myAccountLogoutPage,
  myAccountBaseDomain: config.myAccountBaseDomain,
  domain: config.domain,
});
